module.exports = __webpack_public_path__ + "img/IMG_20210601_141506779_HDR.432a19d4.jpg";